<template>
  <v-container>
    <v-dialog v-model="isShowDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="font-weight-bold text-h4">
          <div
            :class="
              inputColor.titleColor
                ? `${inputColor.titleColor}--text`
                : 'black--text'
            "
          >
            {{ inputInfo.title }}
          </div>
        </v-card-title>
        <v-card-text class="text-body-1">
          <div
            :class="
              inputColor.titleColor
                ? `${inputColor.messageColor}--text`
                : 'black--text'
            "
          >
            {{ inputInfo.message }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="!isLoadingConfirmation"
            :color="
              inputColor.confirmButtonTitleColor
                ? inputColor.confirmButtonTitleColor
                : 'green'
            "
            text
            @click="confirm"
          >
            {{
              inputInfo.confirmButtonTitle
                ? inputInfo.confirmButtonTitle
                : "Confirm"
            }}
          </v-btn>
          <v-progress-circular
            v-if="isLoadingConfirmation"
            indeterminate
            color="green"
            class="ml-2"
            size="26"
            width="2"
          ></v-progress-circular>
          <v-spacer />
          <v-btn
            :color="
              inputColor.cancelButtonTitleColor
                ? inputColor.cancelButtonTitleColor
                : 'grey'
            "
            text
            @click="cancel"
          >
            {{
              inputInfo.cancelButtonTitle
                ? inputInfo.cancelButtonTitle
                : "Cancel"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    isShowDialog: {
      type: Boolean,
      required: true,
      default: false
    },
    inputInfo: {
      type: Object,
      default() {
        return {
          title: "Confirmation",
          message: "Are You Sure You Want To Proceed?",
          confirmButtonTitle: "Confirm",
          cancelButtonTitle: "Cancel"
        };
      }
    },
    inputColor: {
      type: Object,
      default() {
        return {
          titleColor: "black",
          messageColor: "black",
          confirmButtonTitleColor: "green",
          cancelButtonTitleColor: "grey"
        };
      }
    },
    value: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      isLoadingConfirmation: false
    };
  },
  methods: {
    confirm() {
      let newObject = Object.assign({}, { passedData: this.value });
      let combinedData = Object.assign(newObject.passedData, {
        confirmationModalTitle: this.inputInfo.title
      });
      this.$emit("eConfirm", combinedData);
    },
    loading() {
      this.isLoadingConfirmation = true;
    },
    stopLoading() {
      this.isLoadingConfirmation = false;
    },
    cancel() {
      this.$emit("eCancel");
    }
  }
};
</script>
